export default __webpack_public_path__ + "static/media/beforeafter@3x.136ddc9e.png";